/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./volume.vue?vue&type=template&id=6f908012&scoped=true&"
import script from "./volume.vue?vue&type=script&lang=js&"
export * from "./volume.vue?vue&type=script&lang=js&"
import style0 from "./volume.vue?vue&type=style&index=0&id=6f908012&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f908012",
  null
  
)

export default component.exports